/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_Qty_NoteInputs */

const vi_lot_items_split_qty_note = /** @type {(inputs: Lot_Items_Split_Qty_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng KL = tổng các lô con`)
};

/**

* @param {Lot_Items_Split_Qty_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_qty_note = /** @type {((inputs?: Lot_Items_Split_Qty_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_Qty_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_qty_note(inputs)
});